import i18n from "../../../i18n";import { Trans } from "react-i18next";import { useState } from "react";
import { AppLayout, PageBackLink } from "../../../components/layout";
import { AlertBanner, ContentCard, PageHeader } from "../../../components/ui";
import { OrgTableUploadForm } from "../components";
import { uploadOrgTable } from "../../../services/orgTableService";

export function OrgTablesPage() {
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [uploadResult, setUploadResult] = useState(null);

  const handleOrgTableSubmit = async ({ name, file }) => {
    setSuccessMsg("");
    setErrorMsg("");
    setUploadResult(null);
    try {
      const result = await uploadOrgTable(name, file);
      setSuccessMsg(result.message);
      setUploadResult(result.data);
    } catch (err) {
      //setErrorMsg(err.message);
      setErrorMsg(err.errorCode ? `${err.message}: ${err.errorCode}` : err.message);
    }
  };

  return (
    <AppLayout>
      <PageBackLink to="/" />
      <PageHeader
        title={i18n.t("orgTables.organizationTables")} />
      

      {successMsg && <AlertBanner type="success">{successMsg}</AlertBanner>}
      {errorMsg && <AlertBanner type="error">{errorMsg}</AlertBanner>}

      {uploadResult &&
      <AlertBanner type="info">
          <div className="flex flex-wrap gap-6 font-normal">
            <div>
              <strong className="block text-xs uppercase tracking-wide text-[var(--color-text-secondary)] mb-1">
                <Trans i18nKey="orgTables.totalRows" />
              </strong>
              {uploadResult.totalRows}
            </div>
            <div>
              <strong className="block text-xs uppercase tracking-wide text-[var(--color-text-secondary)] mb-1">
                <Trans i18nKey="orgTables.inserted" />
              </strong>
              {uploadResult.insertedRows}
            </div>
            <div>
              <strong className="block text-xs uppercase tracking-wide text-[var(--color-text-secondary)] mb-1">
                <Trans i18nKey="orgTables.skippedDuplicates" />
              </strong>
              {uploadResult.skippedDuplicates}
            </div>
          </div>
        </AlertBanner>
      }

      <ContentCard title={i18n.t("formActions.uploadOrganizationTable")} bodyClassName="p-4 sm:p-6">
        <OrgTableUploadForm onSubmit={handleOrgTableSubmit} />
      </ContentCard>
    </AppLayout>);

}
